import React from 'react'
import styled from '@emotion/styled'
import { handleChipColor } from './utils'

export const GoalsSection = ({ goals }: any) => (
  <>
    <StatContainer>
      AVERAGE PROGRESS TO GOALS:
      <StyledChip
        color={handleChipColor(
          goals?.averageProgressToGoalsUp,
          goals?.averageProgressToGoalsDown
        )}
      >
        {goals?.averageProgressToGoalsPercent}
      </StyledChip>
    </StatContainer>
    <StatContainer>
      GOALS CREATED:
      <StyledChip
        color={handleChipColor(goals?.tasksCreatedUp, goals?.tasksCreatedDown)}
      >
        {goals?.tasksCreated}
      </StyledChip>
    </StatContainer>
    <StatContainer>
      GOALS COMPLETED:
      <StyledChip
        color={handleChipColor(
          goals?.tasksCompletedUp,
          goals?.tasksCompletedDown
        )}
      >
        {goals?.tasksCompleted}
      </StyledChip>
    </StatContainer>

    {goals?.goalsSummaryString}
  </>
)

const StyledChip = styled.div<{ color: string }>`
  height: 24px;
  padding: 2px;
  margin: 2px;
  background-color: ${(props) => props.color};
  color: black;
  border-radius: 4px;
  min-width: 35px;
`

const StatContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
